"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M.386 13.78a2.715 2.715 0 0 0 2.364 1.358h10.493c.991 0 1.881-.517 2.38-1.383a2.71 2.71 0 0 0 .01-2.738l-.434-.758-4.827-8.35A2.698 2.698 0 0 0 7.997.518c-.997 0-1.885.52-2.375 1.385L.357 11.021a2.748 2.748 0 0 0 .029 2.758ZM9.504 2.403l4.828 8.353.435.759a1.72 1.72 0 0 1-.009 1.74 1.735 1.735 0 0 1-1.514.882H2.75a1.726 1.726 0 0 1-1.501-.865 1.753 1.753 0 0 1-.023-1.757L6.49 2.4c.312-.55.875-.88 1.506-.88.63 0 1.194.33 1.507.884Zm-.64 10.18H7.268V10.92h1.596v1.665ZM8.713 5.04H7.4l.163 4.497h1l.15-4.497Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M3.993 22.441h16.003c1.44 0 2.732-.75 3.457-2.008.724-1.254.73-2.74.015-3.977l-.372-.644-7.652-13.248A3.917 3.917 0 0 0 11.995.548 3.915 3.915 0 0 0 8.55 2.56L.519 16.46a3.993 3.993 0 0 0 .041 4.007 3.948 3.948 0 0 0 3.433 1.973ZM14.468 3.122l7.655 13.253.371.643a2.822 2.822 0 0 1-.014 2.853 2.844 2.844 0 0 1-2.484 1.446H3.993a2.829 2.829 0 0 1-2.462-1.418 2.875 2.875 0 0 1-.036-2.881l8.03-13.9a2.805 2.805 0 0 1 2.47-1.445 2.81 2.81 0 0 1 2.473 1.45ZM13.025 18.44h-1.848v-1.927h1.848v1.927Zm.061-11.196h-2l.245 7.252h1.524l.231-7.252Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M5.324 29.922h21.338c1.919 0 3.642-1 4.609-2.678.965-1.672.972-3.654.02-5.302l-.496-.859L20.591 3.42A5.223 5.223 0 0 0 15.994.731a5.22 5.22 0 0 0-4.595 2.682L.691 21.95a5.324 5.324 0 0 0 .056 5.342 5.264 5.264 0 0 0 4.577 2.63ZM19.29 4.162l10.207 17.67.496.86c.681 1.178.674 2.601-.02 3.803a3.792 3.792 0 0 1-3.311 1.927H5.324a3.772 3.772 0 0 1-3.283-1.89 3.833 3.833 0 0 1-.048-3.842L12.7 4.157a3.74 3.74 0 0 1 3.293-1.927c1.38 0 2.612.72 3.297 1.933Zm-1.923 20.425h-2.464v-2.57h2.464v2.57Zm.081-14.929H14.78l.328 9.67h2.033l.308-9.67Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M7.954 45.404h32.182c2.825 0 5.361-1.473 6.785-3.94 1.42-2.462 1.431-5.38.029-7.807l-.598-1.036L30.814 5.719c-1.4-2.477-3.931-3.956-6.768-3.956-2.838 0-5.368 1.479-6.765 3.95L1.135 33.666c-1.386 2.471-1.355 5.412.083 7.865 1.42 2.424 3.938 3.872 6.736 3.872ZM29.185 6.65l15.543 26.908.598 1.037c1.064 1.84 1.053 4.057-.028 5.93-1.086 1.881-3.015 3.004-5.162 3.004H7.954a5.883 5.883 0 0 1-5.118-2.944c-1.098-1.873-1.122-4.117-.072-5.99L18.91 6.641c1.062-1.88 2.982-3.004 5.136-3.004 2.152 0 4.072 1.123 5.14 3.012Zm-3.1 30.989h-3.561v-3.715h3.561v3.715Zm.118-24.471h-3.857l.475 16.868h2.937l.445-16.868Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M10.606 60.539h42.909c3.766 0 7.148-1.964 9.047-5.254 1.894-3.282 1.908-7.172.038-10.408l-.797-1.382-20.718-35.87c-1.867-3.302-5.241-5.274-9.024-5.274-3.784 0-7.157 1.972-9.02 5.266L1.514 44.89c-1.848 3.295-1.806 7.216.11 10.487 1.894 3.232 5.252 5.162 8.983 5.162ZM38.914 8.867l20.724 35.878.797 1.382c1.418 2.454 1.404 5.41-.038 7.908-1.447 2.507-4.02 4.004-6.882 4.004h-42.91c-2.833 0-5.384-1.468-6.824-3.925-1.463-2.498-1.496-5.49-.096-7.988l21.528-37.27C26.63 6.35 29.19 4.852 32.06 4.852c2.87 0 5.43 1.498 6.853 4.016ZM34.78 50.185h-4.748v-4.953h4.748v4.953Zm.158-32.628h-5.143l.633 22.491h3.916l.594-22.491Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconWarning = function IconWarning(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Warning' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Warning"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconWarning.sizes = [16, 24, 32, 48, 64];
IconWarning.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconWarning;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/system/Warning.js
// module id = 2478
// module chunks = 0